import { updateDocument } from 'api/Documents';

import { showAlert } from 'components/shared/Alert/Alert';

import setMultipleQueriesData from '../setMultipeQueriesData';

export default async function handleEdit({
  setEditLoading,
  handle,
  edit,
  navigate,
  queryClient,
  appointmentId,
  viewDocument,
  handleCloseModal,
  myPortalPractice
}) {
  setEditLoading(true);
  const data = await updateDocument(navigate, {
    handle,
    name: edit?.name,
    category: edit?.category?.value,
    myPortalPractice
  });

  if (data?.update > 0) {
    setMultipleQueriesData(
      queryClient,
      [
        'practice-documents',
        [
          'attachment-documents',
          appointmentId?.toString() || viewDocument?.appointment_id?.toString()
        ],
        ['chart-documents', viewDocument?.patient_id]
      ],
      (old) => {
        return {
          ...old,
          documents: old?.documents?.map((item) => {
            if (item?.document_handle === handle) {
              return {
                ...item,
                name: edit.name,
                category: edit?.category?.value?.toString()
              };
            } else {
              return item;
            }
          })
        };
      }
    );
    showAlert({ title: 'Document edited successfully', color: 'success' });
    handleCloseModal();
  } else {
    showAlert({ title: 'There was a problem while editing document.', color: 'danger' });
  }
  setEditLoading(false);
}
